import * as actionTypes from '../actions/ActionTypes';
import * as api from '../../shared/services/api/apiVideo';
import { showListOfVideoMainTopics } from '../actions/VideoActions';
import { all, put, takeEvery } from 'redux-saga/effects';

import { Logout, startLoading, stopLoading } from '../actions/CommonActions';
import { checkOffline } from '../../shared/services/Utility';
import { SESSION_EXPIRED, SESSION_EXPIRED_CODE } from '../../shared/constants/Constants';

function* getVideoMainTopics(action) {
  try {
    yield put(startLoading());
    const data = yield api.getVideoMainTopics(action.videosTopicRequestBody);

    if (data.status === 1) {
      yield put(showListOfVideoMainTopics(data.topicsData));
      yield put(stopLoading());
    } else if (data.status === 0) {

      /*session id expired*/
      yield put(stopLoading());
      yield put(Logout());
      action.openSnackbar(SESSION_EXPIRED, 'error');
    } else {
      if (checkOffline()) {
        action.openSnackbar('You are offline.', 'error');
      } else {
        action.openSnackbar('Sog went wrong.', 'error');
      }
    }
    yield put(stopLoading());
  } catch (e) {

    yield put(stopLoading());
    if (checkOffline()) {
      action.openSnackbar('You are offline.', 'error');
    } else {
      action.openSnackbar('Something went wrong.', 'error');
    }
  }
}

function* getListOfVideos(action) {
  try {
    yield put(startLoading());
    const data = yield api.getVideoInTopics(action.videosRequestBody);

    if (data.status === 1) {
      action.success(data.LessonData);
      yield put(stopLoading());
    } else if (data.status === SESSION_EXPIRED_CODE) {

      /*session id expired*/
      yield put(stopLoading());
      action.errorSnackbar(SESSION_EXPIRED, 'error');
      yield put(Logout());
    } else {
      yield put(stopLoading());
      if (checkOffline()) {
        action.showError('You are offline.', 'error');
      } else {
        action.showError('Something went wrong.', 'error');
      }
    }
    yield put(stopLoading());
  } catch (e) {

    yield put(stopLoading());
    //alert('error ==  ' + e)
    yield put(stopLoading());
    if (checkOffline()) {
      action.showError('You are offline.', 'error');
    } else {
      action.showError('Something went wrong.', 'error');
    }
  }
}

function* videoTopicsSaga() {
  yield all([
    takeEvery(actionTypes.GET_VIDEO_MAIN_TOPICS, getVideoMainTopics),
    takeEvery(actionTypes.GET_VIDEOS, getListOfVideos),
  ]);
}

export default videoTopicsSaga;
